import type { Situacao } from "@base/contracts";
import { cn } from "@base/ui";
import { ROTULO_DA_SITUACAO } from "./textos";

const COR: Readonly<Record<Situacao, string>> = {
  urgente: "bg-destructive/12 text-destructive",
  cronico: "bg-accent text-accent-foreground",
  "aviso-precoce": "bg-warning/15 text-warning-foreground",
  "pouco-volume": "bg-muted text-muted-foreground",
  ok: "bg-success/12 text-success",
};

/** A forma do marcador muda com a situação: a cor não é o único sinal. */
const MARCADOR: Readonly<Record<Situacao, string>> = {
  urgente: "size-[7px] rounded-full bg-current",
  ok: "size-[7px] rounded-full bg-current",
  cronico: "size-[7px] rounded-[2px] bg-current",
  "aviso-precoce": "size-0 border-x-4 border-b-[7px] border-x-transparent border-b-current",
  "pouco-volume": "size-[7px] rounded-full border-[1.5px] border-current",
};

export function SeloDaSituacao({
  situacao,
  rotulo,
  grande = false,
}: {
  readonly situacao: Situacao;
  readonly rotulo?: string;
  readonly grande?: boolean;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full font-semibold",
        grande ? "px-3 py-1.5 text-[13px]" : "px-2.5 py-1 text-xs",
        COR[situacao],
      )}
    >
      <span aria-hidden="true" className={cn("shrink-0", MARCADOR[situacao])} />
      {rotulo ?? ROTULO_DA_SITUACAO[situacao]}
    </span>
  );
}
